import { MinimalAsset } from "datalign-module-template/models/minimal-asset";

const DownloadAsset = async (asset: MinimalAsset) => {
  if (!asset.presigned_url) {
    console.error("No presigned url found");
    return;
  }
  const link = document.createElement("a");
  link.href = asset.presigned_url;
  link.download = asset.name;
  link.target = "_blank";
  link.click();
};

export default DownloadAsset;
